import { getSpecialty } from './getSpecialty';
import { EReadyBusiness, IOffer } from '../../../types/offer';

export function getCommercialBusinessLabel(offer: IOffer): string {
  const businessTypeLabel = (() => {
    switch (offer.readyBusinessType) {
      case EReadyBusiness.ReadyBusiness:
        return 'Готовый бизнес';
      case EReadyBusiness.RentalBusiness:
        return 'Арендный бизнес';
      default:
        return 'Готовый бизнес';
    }
  })();

  const [specialtyLabel] = getSpecialty(offer);

  if (specialtyLabel) {
    const formattedSpecialtyLabel = specialtyLabel[0].toUpperCase() + specialtyLabel.slice(1);

    return `${businessTypeLabel}・${formattedSpecialtyLabel}`;
  }

  return businessTypeLabel;
}
